import API from './api/api';

export default API;
